import React, { useEffect, useRef } from 'react';
import 'jsvectormap/dist/jsvectormap.css';
import jsVectorMap from 'jsvectormap';
import world from 'jsvectormap/dist/maps/world.js';

function WorldMap() {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const containerId = 'regions_purchase_map';

  useEffect(() => {

    if (!mapRef.current) return;

    // Destroy previous map instance if exists
    if (mapInstanceRef.current) {
      try { mapInstanceRef.current.destroy(); } catch (_) {}
      mapInstanceRef.current = null;
    }
    // Clear the container to prevent double map rendering
    mapRef.current.innerHTML = '';

    // Example purchase data by country code (ISO 3166-1 alpha-2 or alpha-3 depending on map)
    const purchases = {
      NG: 320,
      GH: 240,
      KE: 180,
      US: 120,
      GB: 90,
      DE: 70,
      IN: 160,
      BR: 3000, // Brazil
    };

    mapInstanceRef.current = new jsVectorMap({
      selector: `#${containerId}`,
      map: 'world',
      zoomButtons: true,
      regionStyle: {
        initial: { fill: '#e9eef7' },
        hover: { fill: '#4c84ff' },
        selected: { fill: '#80e1c1' },
      },
      // No region labels on the map itself
      series: {
        regions: [
          {
            scale: ['#dce6ff', '#4c84ff'],
            values: purchases,
            legend: { title: 'Purchases' },
          },
        ],
      },
      onRegionTooltipShow(event, tooltip, code) {
        const value = purchases[code] || 0;
        const countryNames = {
          NG: 'Nigeria', GH: 'Ghana', KE: 'Kenya', US: 'United States', GB: 'United Kingdom', DE: 'Germany', IN: 'India', BR: 'Brazil',
        };
        const countryName = countryNames[code] || code;
        if (tooltip && typeof tooltip.innerHTML !== 'undefined') {
          tooltip.innerHTML = `<strong>${countryName}</strong><br/>Purchase: <strong>${value}</strong>`;
        }
      },
    });

    return () => {
      if (mapInstanceRef.current) {
        try { mapInstanceRef.current.destroy(); } catch (_) {}
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div id={containerId} ref={mapRef} style={{ height: '300px', width: '100%' }}></div>
  );
}

export default WorldMap;


